module.exports = __webpack_public_path__ + "img/yszc-cm.e559ac92.png";